import {
    FETCH_TRANSLATORS_FAILURE,
    FETCH_TRANSLATORS_REQUEST,
    FETCH_TRANSLATORS_SUCCESS
} from "./translatorTypes"

const initialState = {
    loading: false,
    translators: [],
    error: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRANSLATORS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_TRANSLATORS_SUCCESS:
            return {
                loading: false,
                translators: action.payload,
                error: '',
            }
        case FETCH_TRANSLATORS_FAILURE:
            return {
                loading: false,
                translators: [],
                error: action.payload
            }
        default: return state;
    }
}
export default reducer;